import React from 'react';
import { useLocation } from 'react-router-dom';
import RiskDetector from '../../components/RiskDetector.js';

const RiskDetectorPage = () => {

    const location = useLocation();
    const uploadedFile = location.state?.uploadedFile || null;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Risk Keyword Detector</h1>
      <RiskDetector/>
    </div>
  );
};

export default RiskDetectorPage;
